import { createContext, useCallback, useContext, useEffect, useState } from "react";

const EnquiryCtx = createContext(null);

export function EnquiryProvider({ children }) {
  const [state, setState] = useState({ isOpen: false, project: null, config: "", intent: "Enquiry" });

  const openPopup = useCallback((opts = {}) => {
    setState({ isOpen: true, project: opts.project || null, config: opts.config || "", intent: opts.intent || "Enquiry" });
  }, []);

  const closePopup = useCallback(() => setState((s) => ({ ...s, isOpen: false })), []);

  useEffect(() => {
    if (sessionStorage.getItem("sca-popup-seen")) return;
    const t = setTimeout(() => {
      openPopup({ intent: "Get Cost Sheet & Brochure" });
      sessionStorage.setItem("sca-popup-seen", "1");
    }, 14000);
    return () => clearTimeout(t);
  }, [openPopup]);

  return <EnquiryCtx.Provider value={{ ...state, openPopup, closePopup }}>{children}</EnquiryCtx.Provider>;
}

export const useEnquiry = () => useContext(EnquiryCtx);
